import styled, { css } from 'styled-components';

import { Div } from './Generic';
import SC from './SC';

export const HTMLContainer = styled(Div)<SC<{ brandColor: string; }>>`
  ${({ theme, sc: { brandColor } = {} }) => css`
    &, .tiptap {
      > * {
        margin: 0 0 ${theme.gutter}px 0;
      }

      > h1 {
        margin-bottom: ${theme.gutter * 0.75}px;
      }

      > h2 {
        margin-bottom: ${theme.gutter * 0.5}px;
      }

      > h3 {
        margin-bottom: ${theme.gutter * 0.25}px;
      }

      hr {
        border-color: ${theme.colors.gray[200]};
        padding: 0;
        margin-top: ${theme.gutter * 1.5}px;
        margin-bottom: ${theme.gutter * 1.5}px;
      }

      > *:first-child {
        margin-top: 0;
      }

      > *:last-child, p:last-child {
        margin-bottom: 0;
      }

      img {
        display: block;
        width: 100%;
        border-radius: ${theme.borderRadiuses.xl}px;
      }

      a.button {
        display: inline-block;
        padding: 10px 16px;
        height: 40px;
        line-height: 20px;
        font-weight: 600;
        background: ${brandColor || theme.colors.secondary[500]};
        color: ${theme.getTitleColor(brandColor || theme.colors.secondary[500])};
        border-radius: ${theme.borderRadiuses.md}px;
      }
    }
  `}
`;

const HTML = ({ html }: { html: string }) => (
  <HTMLContainer dangerouslySetInnerHTML={{ __html: html }} />
);

export default HTML;
